import deliveryProgramApi from "@/api/delivery-program/deliveryProgramApi";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async fetch({dispatch}) {
      try {
        const response = await deliveryProgramApi.fetch();
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetchById({dispatch}, {id}) {
      try {
        const response = await deliveryProgramApi.fetchById(id);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async insert({dispatch}, form) {
      try {
        const response = await deliveryProgramApi.insert(form);
        dispatch('NOTIFY_MSG', 'article.deliveryProgram.notification.save',
          {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async copy({dispatch}, {deliveryProgramId}) {
      try {
        await deliveryProgramApi.copy(deliveryProgramId);
        dispatch('NOTIFY_MSG', 'article.deliveryProgram.notification.save',
          {root: true});
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async update({dispatch}, form) {
      try {
        const response = await deliveryProgramApi.update(form);
        dispatch('NOTIFY_MSG', 'article.deliveryProgram.notification.save',
          {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async delete({dispatch}, id) {
      try {
        await deliveryProgramApi.delete(id);
        dispatch('NOTIFY_MSG', 'article.deliveryProgram.notification.delete',
          {root: true});
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
